export const LISTE = {
  title: 'Liste des types contact',
  breadcrumb: {
    racine: 'Accueil',
    parametrage: 'Paramétrage',
    liste: 'Liste des types contact',
  },
  actions: {
    add: 'Ajouter un type de contact',
    search: 'Rechercher',
    edit: 'Modifier',
    delete: 'Supprimer',
    archiver: 'Archiver',
  },
  tab: {
    libelle: 'Libellé',
    typeContactType: 'Type contact',
  },
};

export const ADD = {
  titleAdd: 'Ajouter un type de contact',
  titleEdit: 'Modifier un type de contact',
  information: {
    libelle: 'Libellé',
    typeContactType: 'Type contact',
  },
  success: {
    add: 'Le type contact a été ajouté avec succès.',
    edit: 'Le type contact a été modifié avec succès.',
  },
  typeContactType: {
    facturation: 'Facturation',
    bat: 'BAT',
    autre: 'Autre',
  },
  error: {},
};
